import {catch403, postRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";

import {TurnstileAction} from "../../app/constants/turnstile_actions";
import {appendTurnstileToken} from "../../app/turnstile";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {ContractorApplicationFormValuesType} from "../components/ContractorApplication";

export const postContractorApplication = async (data: ContractorApplicationFormValuesType) => {
    const payload = await appendTurnstileToken(data, TurnstileAction.CONTRACTOR_CONTACT);

    return postRequest({}, apiLink.contact.contractor(), payload).catch(
        catch403(async (err) => {
            notifyBugsnag(err, "postContractorApplication: catch 403", err.responseError ?? {});
        })
    );
};
import {catch403, postRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";

import {TurnstileAction} from "../../app/constants/turnstile_actions";
import {appendTurnstileToken} from "../../app/turnstile";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {ContractorApplicationFormValuesType} from "../components/ContractorApplication";

export const postContractorApplication = async (data: ContractorApplicationFormValuesType) => {
    const payload = await appendTurnstileToken(data, TurnstileAction.CONTRACTOR_CONTACT);

    return postRequest({}, apiLink.contact.contractor(), payload).catch(
        catch403(async (err) => {
            notifyBugsnag(err, "postContractorApplication: catch 403", err.responseError ?? {});
        })
    );
};
